import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from "@mui/material"
import { v4 as uuidv4 } from "uuid";
import SettingsIcon from '@mui/icons-material/Settings';

// import StateContext from 'src/context/UserProvider';

import NavBarSliderLanguage from 'src/components/common/NavBar/NavBarSliderLanguage';
import FloatingPanel from 'src/components/common/NavBar/FloatingPanel';
import NavBarIconButtonBadge from 'src/components/common/NavBar/NavBarIconButtonBadge';

const MenuButtons = (): React.JSX.Element => {
  const navigate = useNavigate();
  // const { error } = StateContext();
  
  const buttonListIcon = (): React.JSX.Element => {
    return (
      <>
        <NavBarSliderLanguage key={uuidv4()} />
        <FloatingPanel key={uuidv4()} />
        <NavBarIconButtonBadge
          key={uuidv4()}
          elementIcon={<SettingsIcon key={uuidv4()} />}
          numBadge={1}
          fncAction={() => { navigate("/user") }}
        />
      </>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'row',
          p: 0,
          m: 0,
          flexWrap: 'nowrap',
          justifyContent: 'flex-end',
          alignItems: 'right',
        }}
      >
        {buttonListIcon()}
      </Box>
    </>
  );
};

export default MenuButtons;
